import React, { useState, useContext } from 'react';
import { RewardsContext } from '../../context/RewardsContext/RewardsContext';
import FundNameSection from '../../components/FundNameSection/FundNameSection';
import FundCompositionSection from '../../components/FundCompositionSection/FundCompositionSection';
import QuickView from '../../components/QuickView/QuickView';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import Heading from '../../components/Typography/Heading/Heading';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import { US_TREASURY_MM_TICKER, US_TREASURY_ICLASS_MM_TICKER } from './queries';
import styles from './MoneyMarketStyles.css';
import { iClassFundLimits } from '../../hooks/useCartDetailsState';
import { meetsTrustRequirements } from '../../flows/shared/summit.testers';

export const moneyMarketIClassRequirements = (
  accountType,
  amount,
  app,
  iClassFundReward
) => {
  const meetsIClassFundLimits = iClassFundLimits(amount, iClassFundReward);
  // DE68556 - if summit rewards unlock iclass, do secondary Trust requirement check
  if (iClassFundReward) {
    return (
      meetsIClassFundLimits &&
      meetsTrustRequirements(accountType, app?.trust, app?.trustee)
    );
  }

  return meetsIClassFundLimits;
};

const MoneyMarketScreen = ({
  next,
  back,
  appState: {
    store: { accountType, amount, app, loadedData }
  }
}) => {
  const [openQuickViewFund, setOpenQuickViewFund] = useState(false);

  const { rewardsAvailable = {} } = useContext(RewardsContext) || {};
  const { iClassFunds: iClassFundReward } = rewardsAvailable;

  const { moneyMarketFundData = [] } = loadedData || {};
  const investorClassMoneyMarketData = moneyMarketFundData.find(
    fund => fund.ticker === US_TREASURY_MM_TICKER
  );
  const iClassMoneyMarketData = moneyMarketFundData.find(
    fund => fund.ticker === US_TREASURY_ICLASS_MM_TICKER
  );
  // DE68556 - check iclass limits + trust requirements
  const fundData = moneyMarketIClassRequirements(
    accountType,
    amount,
    app,
    iClassFundReward
  )
    ? iClassMoneyMarketData
    : investorClassMoneyMarketData;
  const mmData = {
    ...fundData,
    correspondingFund: iClassMoneyMarketData,
    isMoneyMarketView: true
  };

  return (
    <div className="mm-selection-container">
      <Heading text="Money Market Fund Options" />

      <h3>
        The T. Rowe Price® Select Funds is a simple list, screened from our
        actively managed mutual funds, designed to help you select your
        investments more easily. You may choose the T. Rowe Price® select money
        market fund below or 
        <span className="money-market-funds-btn">
          <MFBeaconButton
            type="button"
            id="viewAllMoneyMarket"
            className="override-beacon-button-padding"
            onClick={next('viewAllMoneyMarketFunds')}
            variant="tertiary"
            label="view all Money Market Funds."
          />
        </span>
      </h3>

      <div className="contents">
        <FundNameSection {...mmData} />

        <FundCompositionSection
          fund={mmData}
          openQuickViewFund={openQuickViewFund}
          setOpenQuickViewFund={setOpenQuickViewFund}
          isMoneyMarketView
        />
      </div>

      {openQuickViewFund && (
        <div>
          <QuickView
            fund={mmData}
            onClose={() => setOpenQuickViewFund(!openQuickViewFund)}
          />
        </div>
      )}
      <div className="bottom">
        <div className="mm-note">
          You could lose money by investing in the Fund. Although the Fund seeks
          to preserve the value of your investment at $1.00 per share, it cannot
          guarantee it will do so. An investment in the Fund is not a bank
          account and is not insured or guaranteed by the Federal Deposit
          Insurance Corporation or any other government agency. T. Rowe Price
          Associates, Inc. is not required to reimburse the Fund for losses, and
          you should not expect that T. Rowe Price Associates, Inc. will provide
          financial support to the Fund at any time, including during periods of
          market stress.
        </div>
        <div className="btn-container">
          <MFBeaconButton
            variant="secondary"
            size="normal"
            id="MoneyMarketScreenBackBtn"
            className="beacon-button-margin-override"
            onClick={back()}
            label="Back"
          />
        </div>
      </div>
      <PhoneNumber />
      <style jsx>{styles}</style>
    </div>
  );
};

export default MoneyMarketScreen;
